import { color } from '../color';
import { getValue } from '../../get-value';

export const colorTextDefaultTokens: Record<string, string> = Object.freeze({
  'color.text': getValue(color, 'default.text.default'),
  'color.text.accent.red': getValue(color, 'default.text.accent.red'),
  'color.text.accent.red.bolder': getValue(
    color,
    'default.text.accent.red-bolder'
  ),
  'color.text.accent.orange': getValue(color, 'default.text.accent.orange'),
  'color.text.accent.orange.bolder': getValue(
    color,
    'default.text.accent.orange-bolder'
  ),
  'color.text.accent.yellow': getValue(color, 'default.text.accent.yellow'),
  'color.text.accent.yellow.bolder': getValue(
    color,
    'default.text.accent.yellow-bolder'
  ),
  'color.text.accent.green': getValue(color, 'default.text.accent.green'),
  'color.text.accent.green.bolder': getValue(
    color,
    'default.text.accent.green-bolder'
  ),
  'color.text.accent.teal': getValue(color, 'default.text.accent.teal'),
  'color.text.accent.teal.bolder': getValue(
    color,
    'default.text.accent.teal-bolder'
  ),
  'color.text.accent.blue': getValue(color, 'default.text.accent.blue'),
  'color.text.accent.blue.bolder': getValue(
    color,
    'default.text.accent.blue-bolder'
  ),
  'color.text.accent.purple': getValue(color, 'default.text.accent.purple'),
  'color.text.accent.purple.bolder': getValue(
    color,
    'default.text.accent.purple-bolder'
  ),
  'color.text.accent.magenta': getValue(color, 'default.text.accent.magenta'),
  'color.text.accent.magenta.bolder': getValue(
    color,
    'default.text.accent.magenta-bolder'
  ),
  'color.text.accent.gray': getValue(color, 'default.text.accent.gray'),
  'color.text.accent.gray.bolder': getValue(
    color,
    'default.text.accent.gray-bolder'
  ),
  'color.text.disabled': getValue(color, 'default.text.accent.disabled'),
  'color.text.inverse': getValue(color, 'default.text.inverse'),
  'color.text.selected': getValue(color, 'default.text.selected'),
  'color.text.brand': getValue(color, 'default.text.brand'),
  'color.text.danger': getValue(color, 'default.text.danger'),
  'color.text.warning': getValue(color, 'default.text.warning'),
  'color.text.warning.inverse': getValue(color, 'default.text.warning-inverse'),
  'color.text.success': getValue(color, 'default.text.success'),
  'color.text.discovery': getValue(color, 'default.text.discovery'),
  'color.text.information': getValue(color, 'default.text.information'),
  'color.text.subtlest': getValue(color, 'default.text.subtlest'),
  'color.text.subtle': getValue(color, 'default.text.subtle')
});
